export default __webpack_public_path__ + "static/media/Girls_Snooze.92a1857c.svg";